export const GET_BOOKINGFORMS = "GET_BOOKINGFORMS";
export const GET_BOOKING_REQUESTS = "GET_BOOKING_REQUESTS";
export const GET_LEASE_REQUESTS = "GET_LEASE_REQUESTS";
export const GET_PLAN_REQUESTS = "GET_PLAN_REQUESTS";



